import { LogoutOutlined } from '@ant-design/icons';
import { Avatar, Modal } from 'antd';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthStore } from '../../../DataSource/Stores/AuthStore';
import { config } from '../../../config';
import Clickable from '../../ui/Clickable';
import * as styles from './ProfileCard.module.scss';

const ProfileCard = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const user = AuthStore.currentUserData.user;

  const fullName = `${user.firstname} ${user.secondname}`.trim() || 'Профиль';
  const initials = `${user.firstname?.charAt(0) ?? ''}${user.secondname?.charAt(0) ?? ''}`.toUpperCase();

  const handleLogout = () => {
    AuthStore.logout();
    navigate('/login');
  };

  return (
    <div className={styles.profile_card}>
      <Avatar
        className={styles.profile_card_avatar}
        size={52}
        src={
          user.photo ? `${config.EXTERNAL_ADDRESS}/image-uploader/${user.photo}` : undefined
        }
      >
        {initials || user.firstname?.charAt(0)?.toUpperCase()}
      </Avatar>

      <div className={styles.profile_card_info}>
        <div className={styles.profile_card_name}>{fullName}</div>
        {user.email && <div className={styles.profile_card_email}>{user.email}</div>}
      </div>

      <Clickable className={styles.profile_card_logout} onClick={() => setModalOpen(true)}>
        <LogoutOutlined />
        Выйти
      </Clickable>

      <Modal
        open={modalOpen}
        closable={false}
        onOk={handleLogout}
        onCancel={() => setModalOpen(false)}
        okText="Да"
        cancelText="Нет"
      >
        <p>Вы точно хотите выйти из аккаунта?</p>
      </Modal>
    </div>
  );
};

export default observer(ProfileCard);
